 
import Axios from '_shared_/plugins/http';
import sanitizeData from '../../shared/utils/sanitize';
import store from '../store';

const http = Axios.Axios;
function setFundDetail({ state, commit, rootState }, data) {
  let url = `${store.state.apiBase}/${data.endpoint}`;
  let dataParams = [];

  if (data.fundClassSymbol) {
    dataParams.push(`fundClassSymbol=${data.fundClassSymbol}`);
  }

  if (data.stagingFlag) {
    dataParams.push(`stagingFlag=${data.stagingFlag}`);
  }

  if (data.fundNumber) {
    dataParams.push(`fundNumber=${data.fundNumber}`);
  }

  if (data.shareClass) {
    dataParams.push(`shareClass=${data.shareClass}`);
  }

  if (data.audience) {
    dataParams.push(`audience=${data.audience}`);
  }

  if (data.params) {
    data.params.forEach(param => {
      dataParams.push(`${param}=${state.fundAttributes.fundAttributes[param]}`);
    });
  }

  dataParams = dataParams.join('&');
  url += `?${dataParams}`;

  const env = store.state.environment === 'production'
    ? 'prodlive'
    : store.state.stagingFlag;

  url += `&dataSet=${env}`;

  if (data.nocache) {
    url += `&..nocache..=${data.nocache}`;
  }

  return makeGet(url, commit, data.commitId, {});
}

function getAndCommit({ state, commit, rootState }, data) {
  let url = `${store.state.apiBase}/${data.endpoint}`;
  let dataParams = [];
  if (data.fundClassSymbol && !data.noSymbol) dataParams.push(`fundClassSymbol=${data.fundClassSymbol}`);
  if (data.stagingFlag) dataParams.push(`stagingFlag=${data.stagingFlag}`);
  if (data.fundNumber) dataParams.push(`fundNumber=${data.fundNumber}`);
  if (data.shareClass) dataParams.push(`shareClass=${data.shareClass}`);
  if (data.audience) dataParams.push(`audience=${data.audience}`);
  if (data.period) dataParams.push(`period=${data.period}`);
  if (data.startDate) dataParams.push(`startDate=${data.startDate}`);
  if (data.endDate) dataParams.push(`endDate=${data.endDate}`);
  if (data.fundSymbol) dataParams.push(`fundSymbol=${data.fundSymbol}`);
  if (data.indexId) dataParams.push(`indexId=${data.indexId}`);
  if (data.assetClass) dataParams.push(`assetClass=${data.assetClass}`);
  if (data.sortBy) dataParams.push(`sortBy=${data.sortBy}`);
  if (data.sortDirection) dataParams.push(`sortDirection=${data.sortDirection}`);
  if (data.firstRow) dataParams.push(`firstRow=${data.firstRow}`);
  if (data.assetType && data.assetType.toLowerCase() !== 'all') dataParams.push(`assetType=${data.assetType}`);
  if (data.fundClassNumber) dataParams.push(`fundClassNumber=${data.fundClassNumber}`);
  if (data.year) dataParams.push(`year=${data.year}`);
  if (data.ticker) dataParams.push(`ticker=${data.ticker}`);
  if (data.inceptionDate) dataParams.push(`inceptionDate=${data.inceptionDate}`);

  const env = store.state.environment === 'production' ? 'prodlive' : store.state.stagingFlag;
  if (data.dataSet) {
    dataParams.push(`dataSet=${data.dataSet}`);
  } else {
    dataParams.push(`dataSet=${env}`);
  }


  if (data.params) {
    data.params.forEach(param => {
      dataParams.push(`${param}=${state.fundAttributes.fundAttributes[param]}`);
    });
  }

  dataParams = dataParams.join('&');
  url += `?${dataParams}`;

  if (data.nocache) {
    url += `&..nocache..=${data.nocache}`;
  }

  let returnValue;
  if (data.mutationNeedsAudience) {
    returnValue = makeGet(url, commit, data.commitId, { mutationNeedsAudience: true, audience: data.audience });
  } else {
    returnValue = makeGet(url, commit, data.commitId, { mutationNeedsAudience: false });
  }
  return returnValue;
}

function getAllStrategies({ state, commit, rootState }, data) {
  const env = store.state.environment === 'production'
    ? 'prodlive'
    : store.state.stagingFlag;

  const url = `https://${store.state.apiBase}/allStrategies/${data.objectiveList}/${data.assetTypeList}/${env}`;

  return makeGet(url, commit, data.commitId, {});
}

async function makeGet(url, commit, commitId, { mutationNeedsAudience, audience }) {
  let response;
  try {
    response = await http.get(url);
  } catch (error) {
    console.error('actions.js error: ', error);
  }
  if (response && commitId) {
    let payload;
    // In some mutations we will need audience because it effects how we set the data to the state. For Example SET_DESCRIPTIONS
    if (mutationNeedsAudience) {
      payload = response.data.data ?
        { payload: sanitizeData(response.data.data), audience } :
        { payload: sanitizeData(response.data), audience };
    } else {
      payload = response.data.data ?
        sanitizeData(response.data.data) :
        sanitizeData(response.data);
    }
    commit(commitId, payload);

  }

  return response;
}

export default {
  setFundDetail,
  getAndCommit,
  getAllStrategies
};
